<div class="placement-excellence-container-fluid">
  <div class="row justify-content-center">
    @for (item of tableItems; track item) {
      <div class="col-sm-12 col-md-6 col-lg-3 mb-3 quick-ref-card-container">
        <div class="card">
          <div class="btn-toolbar card-header" role="toolbar" aria-label="Toolbar Actions">
            <h6 class="card-title">{{ item.category }}</h6>
          </div>
          <div class="card-body">
            <ul>
              @for (i of item.items; track i) {
                <li>
                  {{ i }}
                </li>
              }
            </ul>
          </div>
        </div>
      </div>
    }
  </div>
</div>
